import Apiservice from '@/core/services/api.service';
import { API_URL } from '@/common/config.js'
const apiService = Apiservice;


export default class GatePassService {
    #api = null;

    constructor() {
        this.#api = `${API_URL}user/gate-pass`;
    }

    paginate(data={},index = null) {
        let url = `${this.#api}`;
        if (index != null)
                url = `${url}?page=${index}`;
        let param ={
                params: data
        }
        return apiService.query(url,param);
    }

    update(id, data) {
        let url = `${this.#api}/${id}`
        return apiService.put(url, data);
    }

    store(data) {
        let url = `${this.#api}`
        return apiService.post(url, data);
    }

    show(id) {
        let url = `${this.#api}/${id}`
        return apiService.get(url);
    }

    delete(id) {
        let url = `${this.#api}/${id}`
        return apiService.delete(url);
    }

    changeIsUsedStatus(id){
        let url = `${this.#api}/${id}/change/is-used-status`
        return apiService.post(url);
    }

    approve(id){
        let url = `${this.#api}/${id}/approve`
        return apiService.post(url);
    }

    disapprove(id){
        let url = `${this.#api}/${id}/disapprove`
        return apiService.post(url);
    }

    print(gatePassId){
        let url = `${this.#api}/${gatePassId}/print`
        window.open(url, '_blank');
    }

    getPendingGatePassCounts(){
        let url = `${this.#api}/pending/count`
        return apiService.get(url);
    }
}
